export default __webpack_public_path__ + "_/shared_modules/PlatformError/images/timer-af573e6a5b9cd6886ff87e309173fac1.svg";